import Link from 'next/link';

export const UsefulLinksPartial = () => (
  <div className="root">
    <h3>Nyttige lenker</h3>
    <ul>
      <li>
        <Link href="/boliglan/lanekalkulator">
          <a>Boliglånskalkulator</a>
        </Link>
      </li>
      <li>
        <Link href="/boliglan/refinansiering">
          <a>Refinansiering av boliglån</a>
        </Link>
      </li>
      <li>
        <Link href="/forsikring/bilforsikring">
          <a>Har du den billigste og beste bilforsikringen?</a>
        </Link>
      </li>
      <li>
        <Link href="/privatokonomi/finansiere-bilkjop">
          <a>Hvordan kan du finansiere bilkjøpet smartest?</a>
        </Link>
      </li>
    </ul>
    <style jsx>{`
      .root {
        margin: 48px auto 0 auto;
        color: var(--bgBlueish__text);
      }

      h3 {
        font-size: 22px;
        color: var(--bgBlueish__text);
      }

      li {
        margin-top: 9px;
        font-size: 18px;
      }

      a {
        color: var(--bgBlueish__tintedText);
        text-decoration: none;
      }

      a:hover {
        text-decoration: underline;
      }
    `}</style>
  </div>
);
